import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Copy from '../Copy'
import Flex from '../Flex'
import Icon from '../Icon'
import { themeColor } from '../../util/themeLenses'

const ValidatorBoxStyled = styled(Flex)`
    display: inline-flex;
    background-color: ${props => props.valid ? themeColor('success20') : themeColor('lightGray20')};
    border-radius: 2em;
    margin-top: 8px;
    margin-right: 8px;
    color: ${props => props.valid ? themeColor('green') : themeColor('gray70')};
`

ValidatorBoxStyled.defaultProps = {
    padding: '6px 12px',
    gridGap: '0 8px',
}

const ValidatorBox = ({ valid, padding, typeValidationText, ...restProps }) => {
return (
    <ValidatorBoxStyled valid={valid} padding={padding}>
        {valid && <Icon type='ok' size='xxxSmall' color='green' />}
        <Copy {...restProps} padding='0' fontColor='inherit' as='span'>{typeValidationText}</Copy>
    </ValidatorBoxStyled>
    )
}

ValidatorBox.propTypes = {
    valid: PropTypes.bool,
    typeValidationText: PropTypes.node,
    padding: PropTypes.any,
}

export default ValidatorBox
